import { combineReducers } from 'redux';
import {
  INVENTORY_PURCHASE_ORDER_SET_OUTLETS,
  INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER,
  INVENTORY_PURCHASE_ORDER_SET_CURRENT_PAGE,
  INVENTORY_PURCHASE_ORDER_SET_TOTAL_PAGE,
  INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN,
  INVENTORY_PURCHASE_ORDER_CLOSE_RIGHT_COLUMN,
  INVENTORY_PURCHASE_ORDER_SET_SUPPLIERS,
  INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER_DETAIL,
  INVENTORY_PURCHASE_ORDER_SHOW_MODAL_ITEM,
  INVENTORY_PURCHASE_ORDER_CLOSE_MODAL_ITEM,
  INVENTORY_PURCHASE_ORDER_IS_LOADING,
  INVENTORY_PURCHASE_ORDER_SET_DATA_SEARCH,
  INVENTORY_PURCHASE_ORDER_SET_SELECTED_OUTLET,
  INVENTORY_PURCHASE_ORDER_SET_ADDED_ITEM,
  INVENTORY_PURCHASE_ORDER_HIDE_CONFIRM_SUBMIT_MODAL,
  INVENTORY_PURCHASE_ORDER_SHOW_CONFIRM_SUBMIT_MODAL,
  INVENTORY_PURCHASE_ORDER_SET_IS_ITEM_ADDED,
  INVENTORY_PURCHASE_ORDER_SET_FIRST_ITEMS,
  INVENTORY_PURCHASE_ORDER_SHOW_IMPORT_MODAL,
  INVENTORY_PURCHASE_ORDER_HIDE_IMPORT_MODAL,
  INVENTORY_PURCHASE_ORDER_EXPORT_START,
  INVENTORY_PURCHASE_ORDER_EXPORT_DONE,
  INVENTORY_PURCHASE_ORDER_SET_ASYNCJOBID,
  INVENTORY_PURCHASE_ORDER_IS_SUBMITTING_FORM,
} from 'actions/inventory/purchaseOrder/constants';
import createReducer from 'utils/createReducer';

const addItems = createReducer(
  {
    isLoading: false,
    items: [],
    firstItems: [],
  },
  {
    [INVENTORY_PURCHASE_ORDER_IS_LOADING]: (draft, { payload }) => {
      draft.isLoading = payload.isLoading;
    },

    [INVENTORY_PURCHASE_ORDER_SET_DATA_SEARCH]: (draft, { payload }) => {
      draft.items = payload.items;
    },

    [INVENTORY_PURCHASE_ORDER_SET_FIRST_ITEMS]: (draft, { payload }) => {
      draft.firstItems = payload.firstItems;
    },
  }
);

const alreadyAddedItem = createReducer(false, {
  [INVENTORY_PURCHASE_ORDER_SET_IS_ITEM_ADDED]: (draft, { payload }) =>
    payload.isAdded,
});

const confirmSubmitModal = createReducer(
  {
    show: false,
    action: null,
  },
  {
    [INVENTORY_PURCHASE_ORDER_HIDE_CONFIRM_SUBMIT_MODAL]: () => ({
      show: false,
      action: null,
    }),

    [INVENTORY_PURCHASE_ORDER_SHOW_CONFIRM_SUBMIT_MODAL]: (
      draft,
      { payload }
    ) => ({
      show: true,
      action: payload.action,
    }),
  }
);

const currentPage = createReducer(null, {
  [INVENTORY_PURCHASE_ORDER_SET_CURRENT_PAGE]: (draft, { payload }) =>
    payload.page,
});

const idAsyncJob = createReducer(null, {
  [INVENTORY_PURCHASE_ORDER_SET_ASYNCJOBID]: (draft, { payload }) =>
    payload.idAsyncJob,
});

const isExportLoading = createReducer(false, {
  [INVENTORY_PURCHASE_ORDER_EXPORT_START]: () => true,
  [INVENTORY_PURCHASE_ORDER_EXPORT_DONE]: () => false,
});

const openRightColumn = createReducer(false, {
  [INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN]: () => true,
  [INVENTORY_PURCHASE_ORDER_CLOSE_RIGHT_COLUMN]: () => false,
});

const outlets = createReducer([], {
  [INVENTORY_PURCHASE_ORDER_SET_OUTLETS]: (draft, { payload }) =>
    payload.outlets,
});

const purchaseOrderDetail = createReducer(null, {
  [INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER_DETAIL]: (draft, { payload }) =>
    payload.purchaseOrder,
});

const purchaseOrders = createReducer([], {
  [INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER]: (draft, { payload }) =>
    payload.purchaseOrders,
});

const rightColumnState = createReducer('', {
  [INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN]: (draft, { payload }) =>
    payload.rightColumnState,
});

const selectedOutlet = createReducer(null, {
  [INVENTORY_PURCHASE_ORDER_SET_SELECTED_OUTLET]: (draft, { payload }) =>
    payload.outletId,
});

const showImportModal = createReducer(false, {
  [INVENTORY_PURCHASE_ORDER_SHOW_IMPORT_MODAL]: () => true,
  [INVENTORY_PURCHASE_ORDER_HIDE_IMPORT_MODAL]: () => false,
});

const showModalItem = createReducer(false, {
  [INVENTORY_PURCHASE_ORDER_SHOW_MODAL_ITEM]: () => true,
  [INVENTORY_PURCHASE_ORDER_CLOSE_MODAL_ITEM]: () => false,
});

const suppliers = createReducer([], {
  [INVENTORY_PURCHASE_ORDER_SET_SUPPLIERS]: (draft, { payload }) =>
    payload.suppliers,
});

const temporaryItem = createReducer(null, {
  [INVENTORY_PURCHASE_ORDER_SET_ADDED_ITEM]: (draft, { payload }) =>
    payload.item,
});

const totalPage = createReducer(null, {
  [INVENTORY_PURCHASE_ORDER_SET_TOTAL_PAGE]: (draft, { payload }) =>
    payload.page,
});

const disabledCreateAndFulfillButton = createReducer(false, {
  [INVENTORY_PURCHASE_ORDER_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    payload.isSubmittingForm,
});

export default combineReducers({
  addItems,
  alreadyAddedItem,
  confirmSubmitModal,
  currentPage,
  idAsyncJob,
  isExportLoading,
  openRightColumn,
  outlets,
  purchaseOrderDetail,
  purchaseOrders,
  rightColumnState,
  // FIXME camelcase
  selected_outlet: selectedOutlet,
  showImportModal,
  showModalItem,
  suppliers,
  temporaryItem,
  totalPage,
  disabledCreateAndFulfillButton,
});
